import dayjs from "dayjs";
import { zWorkShiftSchemaDto, zWorkShiftCreateSchemaDto, } from "@/types/workShift/workShift.dto";
import { zWorkShiftSchemaDom, zWorkShiftCreateSchemaDom, } from "@/types/workShift/workShift.domain";
/**
 * WorkShift Mapper: DTO <-> Domain
 * Handles conversion between DTO (ISO strings) and Domain (dayjs objects)
 */
export const WorkShiftMapper = {
    /**
     * Преобразование из DTO в Domain (строки ISO в dayjs объекты)
     */
    toDomain: (dto) => {
        const parsed = zWorkShiftSchemaDto.parse(dto);
        const { plannedEndTime, plannedStartTime, actualEndTime, actualStartTime, ...rest } = parsed;
        return zWorkShiftSchemaDom.parse({
            ...rest,
            plannedStartTime: dayjs(plannedStartTime),
            plannedEndTime: dayjs(plannedEndTime),
            actualStartTime: actualStartTime ? dayjs(actualStartTime) : null,
            actualEndTime: actualEndTime ? dayjs(actualEndTime) : null,
        });
    },
    /**
     * Преобразование из Domain в DTO (dayjs объекты в строки ISO)
     */
    toDto: (domain) => {
        const parsed = zWorkShiftSchemaDom.parse(domain);
        const { plannedStartTime, plannedEndTime, actualStartTime, actualEndTime, status, ...rest } = parsed;
        return zWorkShiftSchemaDto.parse({
            ...rest,
            plannedStartTime: plannedStartTime.toISOString(),
            plannedEndTime: plannedEndTime.toISOString(),
            actualStartTime: actualStartTime ? actualStartTime.toISOString() : null,
            actualEndTime: actualEndTime ? actualEndTime.toISOString() : null,
        });
    },
    /**
     * Специализированный метод для WorkShiftCreateData
     */
    toCreateWorkShiftDto: (domain) => {
        const safeDomain = zWorkShiftCreateSchemaDom.parse(domain);
        const { plannedStartTime, plannedEndTime, actualStartTime, actualEndTime, status, ...rest } = safeDomain;
        return zWorkShiftCreateSchemaDto.parse({
            ...rest,
            plannedStartTime: plannedStartTime.toISOString(),
            plannedEndTime: plannedEndTime.toISOString(),
            actualStartTime: actualStartTime ? actualStartTime.toISOString() : null,
            actualEndTime: actualEndTime ? actualEndTime.toISOString() : null,
        });
    },
};
